<ngx-codemirror
  [ngModel]="model"
  [options]="options"
  (ngModelChange)="emitValue($event)"
></ngx-codemirror>
